module.exports = __webpack_public_path__ + "static/img/store-logo.42f11fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store-logo.png
// module id = 5pz2
// module chunks = 18